export default __webpack_public_path__ + "static/media/PRM-Assist-Logo-Col.a9d089d6.png";